import {Injectable} from '@angular/core';
import {environment} from "@environments/environment";
import {TableOptionsService} from "@app/_services/table-options.service";
import {
    BackoutRequest,
    BackoutResponse,
    EdiFileSummaryFilter,
    EdiFileSummaryResponse,
    EdiInvalidIdentifier,
    ReprocessingFile,
    ReprocessingResponse
} from "@app/_models/api";
import {GlobalService} from "@app/_services/global.service";
import {Observable} from "rxjs";
import {ApiService} from "@app/_services/api.service";

@Injectable({
  providedIn: 'root'
})
export abstract class EdiFileBaseService extends TableOptionsService<EdiFileSummaryResponse> {

    protected constructor(globalService: GlobalService, public apiService: ApiService) {
        super();
        this.pageSize = globalService.pagination[0];
        this.sortDirection = 'desc';
        this.sortColumn = 'loadTime';
    }

    public abstract fileType: string;

    abstract getFiles(filter: EdiFileSummaryFilter): Observable<EdiFileSummaryResponse[]>;

    abstract getInvalidIdentifiers(customerId: string): Observable<EdiInvalidIdentifier[]>;

    abstract submitReprocessingRequest(files: ReprocessingFile[]): Observable<ReprocessingResponse>;

    abstract submitBackoutRequest(files: BackoutRequest[]): Observable<BackoutResponse>;

    downloadRawFile(fileGuid: string): void {
        const endpoint = `${environment.apiUrl}/admin/processing/${this.fileType}/${fileGuid}`;
        this.apiService.handleDownloadFile(endpoint);
    }

    downloadCleansedFile(fileGuid: string): void {
        const endpoint = `${environment.apiUrl}/admin/processing/${this.fileType}/${fileGuid}/cleansed`;
        this.apiService.handleDownloadFile(endpoint);
    }

    public override matches(element: EdiFileSummaryResponse, term: string) {
        return (
            element.customerName?.toLowerCase().includes(term.toLowerCase()) ||
            element.tradingPartnerName?.toLowerCase().includes(term.toLowerCase()) ||
            element.fileName?.toLowerCase().includes(term.toLowerCase())
        );
    }
}
